import { render, staticRenderFns } from "./DisplayDate.vue?vue&type=template&id=f65935a0&scoped=true&"
import script from "./DisplayDate.vue?vue&type=script&lang=js&"
export * from "./DisplayDate.vue?vue&type=script&lang=js&"
import style0 from "./DisplayDate.vue?vue&type=style&index=0&id=f65935a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65935a0",
  null
  
)

export default component.exports